





















import { Component, Vue, Prop } from 'vue-property-decorator';
import MenuItem from '@pjn/core/model/app/MenuItem';
import SidebarItem from './SidebarItem.vue';

/**
 * Item de menu Inline (no extendido)
 */
@Component({ components: { SidebarItem } })
export default class ToolbarInlineMenuItem extends Vue {

  /** Item del menu a mostrar (simple o con hijos) */
  @Prop() item: MenuItem;

  /** Item seleccionado */
  @Prop({ required: false }) selectedItem: MenuItem | null;

  get hasSubItems() {
    return (this.item && this.item.subItems && this.item.subItems.length > 0);
  }

  get selected() {
    if (!this.item || !this.selectedItem) return false;
    return (this.selectedItem === this.item) || (this.item.subItems && this.item.subItems.find(i => i === this.selectedItem));
  }
}
